import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import userInterfaceUtils from '../../../../utils/userInterfaceUtils';
import './RailcardsFilter.scss';

const filterOptions = {
  age: {
    label: 'How old are you?',
    options: [
      { name: '16-17', value: '16-17' },
      { name: '18-25', value: '18-25' },
      { name: '26-30', value: '26-30' },
      { name: '31-59', value: '31-59' },
      { name: '60+', value: '60' },
    ],
  },
  travelWith: {
    label: 'Who do you usually travel with?',
    options: [
      { name: 'Alone', value: 'alone' },
      { name: 'With a friend', value: 'partner' },
      { name: 'As a family', value: 'children' },
    ],
  },
  travelSE: {
    label: 'Do you travel in London and the South East?',
    options: [
      { name: 'Yes', value: 'yes' },
      { name: 'No', value: 'no' },
    ],
  },
};

export default function RailcardsFilter() {
  const dispatch = useDispatch();

  const renderFilters = () => {
    return Object.keys(filterOptions).map((key) => {
      const filter = filterOptions[key];
      return (
        <div className="custom-select" key={key}>
          <label htmlFor={`filter-${key}`} className="form-label">
            {filter.label}
          </label>
          <select
            id={`filter-${key}`} // Correctly matches the label's htmlFor
            className="form-select"
            aria-label={filter.label} // Accessible name for the select
            onChange={(e) =>
              dispatch({
                type: 'railcards/filterRailcards',
                data: { name: key, value: e.target.value },
              })
            }
          >
            <option value="select" disabled hidden selected>
              Select an option
            </option>
            {filter.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      );
    });
  };

  const goToRailcards = (e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    const el = document.getElementById('railcard-options');
    el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  useEffect(() => {
    userInterfaceUtils.deepLinkAndSmoothScrollToPageElement('choose-railcard');
  }, []);

  return (
    <section id="choose-railcard" className="railcard-filters">
      <h1>Choose your Railcard</h1>
      <p>
        Not sure which Railcard is right for you? Use our handy Railcard Calculator below. Or you
        can{' '}
        <a onClick={goToRailcards} href="#railcard-options">
          skip this step
        </a>{' '}
        if you know which one you need.
      </p>
      <div className="railcard-filters__selectors">{renderFilters()}</div>
    </section>
  );
}
